import Heading from "@arachnys/styleguide/Heading";
import { Fieldset } from "@arachnys/styleguide/Fieldset";
import { css } from "glamor";
import React from "react";
import PropTypes from "prop-types";

import { Comments } from "@arachnys/flow-app/src/component/Comments";

const styles = {
    commentWrapper: css({
        paddingTop: "7px",
    }),
};

const DEFAULT_TAGS = {
    system: "request_portal",
};

const CommentForm = ({ ulid, tags = {} }) => (
    <>
        <Heading level={1}>Contact Deloitte</Heading>
        <Fieldset {...styles.commentWrapper}>
            <Comments
                key={ulid}
                roomID={ulid}
                tags={{
                    values: { ...DEFAULT_TAGS, ...tags },
                    filterBy: Object.keys({ ...DEFAULT_TAGS, ...tags }),
                }}
            />
        </Fieldset>
    </>
);

CommentForm.propTypes = {
    ulid: PropTypes.string.isRequired,
    tags: PropTypes.object,
};

export default CommentForm;
